import { DayOfWeek } from './types';

export const RATIO_MIN = 0;
export const RATIO_MAX = 1;
export const RATIO_PERCENT_MIN = 0;
export const RATIO_PERCENT_MAX = 100;
export const HOURS_MIN = 0;
export const HOURS_MAX = 360;

export const DAYS_OF_WEEK: { key: string; abbr: string; weekDay: DayOfWeek }[] = [
	{ key: 'RESERVE_CAPACITY.MONDAY', abbr: 'RESERVE_CAPACITY.MON', weekDay: DayOfWeek.Monday },
	{ key: 'RESERVE_CAPACITY.TUESDAY', abbr: 'RESERVE_CAPACITY.TUE', weekDay: DayOfWeek.Tuesday },
	{ key: 'RESERVE_CAPACITY.WEDNESDAY', abbr: 'RESERVE_CAPACITY.WED', weekDay: DayOfWeek.Wednesday },
	{ key: 'RESERVE_CAPACITY.THURSDAY', abbr: 'RESERVE_CAPACITY.THU', weekDay: DayOfWeek.Thursday },
	{ key: 'RESERVE_CAPACITY.FRIDAY', abbr: 'RESERVE_CAPACITY.FRI', weekDay: DayOfWeek.Friday },
	{ key: 'RESERVE_CAPACITY.SATURDAY', abbr: 'RESERVE_CAPACITY.SAT', weekDay: DayOfWeek.Saturday },
	{ key: 'RESERVE_CAPACITY.SUNDAY', abbr: 'RESERVE_CAPACITY.SUN', weekDay: DayOfWeek.Sunday }
];
